module.exports = __webpack_public_path__ + "media/dashboard/assets/images/mobile-user-group-01-e6cd816cdbe538ea2482e51787d8a8e7.svg";